export default [
  {
    path: '/takeRedPacket',
    name: 'takeRedPacket',
    component: () => import('@/views/takeRedpack/takeRedpack'),
    meta: {
      roles: ['distributor', 'customer'],
    },
  },
]
